export default theme => ({
  confirm: {
    marginBottom: 20,
  },
});
